import React, { useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import { trans } from '../../../../_providers/Translation'
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"
import { add } from 'lodash'

export default function EmployeeInfoPopup({ employee, visible, onClose }) {
    const ref = useRef(null)

    useEffect(() => {
        if (!visible) return
        const handleKey = (e) => { if (e.key === 'Escape') onClose() }
        document.addEventListener('keydown', handleKey)
        return () => document.removeEventListener('keydown', handleKey)
    }, [visible, onClose])

    if (!visible || !employee) return null

    const vanArray = (() => {
        if (!employee || !employee.van) return []
        if (Array.isArray(employee.van)) return employee.van
        try {
            if (typeof employee.van === 'string') {
                const parsed = JSON.parse(employee.van)
                return Array.isArray(parsed) ? parsed : [parsed]
            }
            return typeof employee.van === 'object' ? [employee.van] : []
        } catch (err) {
            console.error('Employee van parse error', err)
            return typeof employee.van === 'object' ? [employee.van] : []
        }
    })()

    const addressesArray = (() => {
        if (!employee) return []
        if (Array.isArray(employee.addresses) && employee.addresses.length) return employee.addresses

        // fallback to region/area/name if present
        if (employee.region || employee.area || employee.city || employee.postcode) {
            return [{
                name: employee.name || null,
                region: employee.region || null,
                area: employee.area || null,
                city: employee.city || null,
                postcode: employee.postcode || null,
                address: employee.address || null
            }]
        }
        return []
    })()

    const avatar = employee.avatar || employee.image || null

    return (
        <div className={`${visible && employee ? 'visible' : ''} overlay`}>

            <div className={`${visible && employee ? 'show' : ''} medium popup-primary`}>
                <div className='head-new'>
                    <img
                        src={avatar ? avatar : popupDefaultHeadImage}
                        alt="icon"
                        style={{
                            borderRadius: "50%",
                            objectFit: 'cover',
                        }}
                    />
                    <div className='texts'>
                        <h2>
                            {employee.full_name || `${employee.name} ${employee.lastname}`}
                        </h2>
                        <p>
                            {trans('labels.informationForSelectedTechnician')}
                        </p>
                    </div>
                    <span className='close' onClick={onClose}>

                    </span>
                </div>


                {addressesArray.length === 0 && vanArray.length === 0 && (!employee.appliances || employee.appliances.length === 0) ?
                    <div className="alert info">
                        Няма информация за техникa.
                    </div>
                    :
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 12 }}>
                        {addressesArray.length > 0 && (
                            <div>
                                <div style={{ fontWeight: 700, color: '#111827', marginBottom: 6 }}>{trans('labels.area') || 'Район:'}</div>
                                <div style={{ color: '#374151' }}>
                                    {addressesArray.map((ad, i) => (
                                        <div key={ad.id || i} style={{ marginBottom: i < addressesArray.length - 1 ? 8 : 0 }}>
                                            {ad.name || ad.postcode || [ad.city, ad.neighborhood, ad.region, ad.postcode].filter(Boolean).join(', ')}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {(vanArray.length > 0) && (
                            <div>
                                <div style={{ fontWeight: 700, color: '#111827', marginBottom: 6 }}>{trans('labels.auto') || 'Автомобил:'}</div>
                                <div style={{ color: '#374151' }}>
                                    {vanArray.map((v, i) => (
                                        <div key={v.id || v.reg_no || i} style={{ marginBottom: i < vanArray.length - 1 ? 8 : 0 }}>
                                            {[v.brand, v.model].filter(Boolean).join(' ')}
                                            {v.reg_no || v.plate || v.registration ? ` / reg. № ${v.reg_no || v.plate || v.registration}` : ''}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {employee.appliances && employee.appliances.length > 0 && (
                            <div>
                                <div style={{ fontWeight: 700, color: '#111827', marginBottom: 6 }}>{trans('labels.qualifications') || 'Квалификации:'}</div>
                                <div style={{ color: '#374151', lineHeight: '1.4' }}>
                                    {employee.appliances.map(a => a.name).join(', ')}
                                </div>
                            </div>
                        )}
                    </div>
                }

                <div className="footer align-right">
                    <button onClick={onClose}>
                        {trans('buttons.close')}
                    </button>
                </div>

            </div>
        </div>
    )
}